module.exports = __webpack_public_path__ + "static/media/24UHCHR19.a3cdc46c.jpg";